// Order seems to affect how the CSS behaves. Let's ignore sorting in this file for now
import "@/sentry";
import { Switch, Route } from "react-router-dom";

// ----------------------------------------------------

import { ROUTES } from "@/routes_new";
import PublicSingleMentionView from "@/views/PublicSingleMentionView";
import I18nProvider from "@/containers/I18nProvider";
import RegisterChartLocale from "@components/Charts/RegisterChartLocale";
import { useHotjar } from "@/hotjar";

const LocalizedPublicRoot = () => {
  useHotjar();
  return (
    <I18nProvider>
      <Switch>
        <Route
          path={ROUTES.MENTIONS_SINGLE_PUBLIC}
          component={PublicSingleMentionView}
        />
      </Switch>
      <RegisterChartLocale />
    </I18nProvider>
  );
};

export default LocalizedPublicRoot;
